import React from 'react'

export default function Marketing () {
  return (
    <div style={{ margin: 18 }}>
      <h1>Marketing [English]</h1>
      <div>
        <ul>

          <li>
            <a href="https://e-flyers.s3.us-west-2.amazonaws.com/2026+ConsumerNet+ENGLISH.pdf" target="_blank" rel='noreferrer'>
              2026 ConsumerNet Retail Marketing Program
            </a>
          </li>

          <li>
            <a href="https://e-flyers.s3.us-west-2.amazonaws.com/RVPF+ENGLISH+2026.pdf" target="_blank" rel='noreferrer'>
              2026 RV Partfinder Subscription Agreement
            </a>
          </li>

          <li>
            <a href="https://e-flyers.s3.us-west-2.amazonaws.com/Website+Access+Request+fillable.pdf" target="_blank" rel='noreferrer'>
              Website Access Request Form
            </a>
          </li>

          <li>
            <a href="https://e-flyers.s3.us-west-2.amazonaws.com/Carded.pdf" target="_blank" rel='noreferrer'>
              Carded Products (Brochure)
            </a>
          </li>

          <li>
            <a href="https://e-flyers.s3.us-west-2.amazonaws.com/Sureline+Fillable+Form.pdf" target="_blank" rel='noreferrer'>
             Sureline Custom Mattresses
            </a>
          </li>
  
        </ul>


        <div style={{ margin: 18 }}>
          <h1>Commercialisation [French]</h1>
          <div>
            <ul>

              <li>
                <a href="https://e-flyers.s3.us-west-2.amazonaws.com/2026+ConsumerNet+FRENCH.pdf" target="_blank" rel='noreferrer'>
                  2026 Programme de Marketing de détail de ConsumerNet
                </a>
              </li>

              <li>
                <a href="https://e-flyers.s3.us-west-2.amazonaws.com/RVPF+FRENCH+2026.pdf" target="_blank" rel='noreferrer'>
                  2026 Accord de Souscription RV Partfinder
                </a>
              </li>

              <li>
                <a href="https://e-flyers.s3.us-west-2.amazonaws.com/Website+Access+Request+French.pdf" target="_blank" rel='noreferrer'>
                  Formulaire de demande d'accès au site web
                </a>
              </li>

              <li>
                <a href="https://s3.amazonaws.com/atlastrailer.com/Carded+Product+Brochure+FRENCH.pdf" target="_blank" rel='noreferrer'>
                  Produits Cartonés (Brochure)
                </a>
              </li>

              <li>
                <a href="https://e-flyers.s3.us-west-2.amazonaws.com/Sureline+Fillable+Form.pdf" target="_blank" rel='noreferrer'>
                  Matelas personnalisés Sureline
                </a>
              </li>
  
            </ul>
          </div>
        </div>
      </div>
    </div>
  )

}
